export const LoginConfig = {
  fields: [
    {
      name: 'email',
      placeholder: 'Email',
      type: 'text'
    },
    {
      name: 'password',
      placeholder: 'Password',
      type: 'password'
    }
  ]
};

export default LoginConfig;



// WEBPACK FOOTER //
// ./src/actions/auth/configs/LoginConfig.js